import { render } from "./Verification.vue?vue&type=template&id=6ab61c71&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/AuthenticationModals/Verification.css?vue&type=style&index=0&id=6ab61c71&lang=css&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab61c71"]])

export default __exports__